import { observable, IObservableArray } from "mobx";
import { EmptyESId } from "./enums";
import { copy, mapArray } from "../utils/data";

export class SkillSuggestion {
  @observable id: string;
  @observable title: string;
  @observable description: string;
  @observable totalLevel: number;
  @observable totalCompetence: Array<number>;
  @observable positionIds: Array<string>;
  @observable positionCt: number;
  @observable usedPct: number;
  @observable level: number;
  @observable initCompetence: Array<number>;

  constructor(ss?: SkillSuggestion) {
    this.id = EmptyESId;
    this.title = this.description = "";
    this.totalLevel = this.positionCt = this.usedPct = this.level = 0;
    this.totalCompetence = new Array<number>();
    this.positionIds = new Array<string>();
    this.initCompetence = new Array<number>();
    if (ss) {
      copy(ss, this, ["totalCompetence", "positionIds", "initCompetence"]);
      mapArray(ss.totalCompetence, this.totalCompetence);
      mapArray(ss.positionIds, this.positionIds);
      mapArray(ss.initCompetence, this.initCompetence);
    }
  }
}


// WEBPACK FOOTER //
// ./src/models/skills.ts